module.exports = __webpack_public_path__ + "c_static/img/1搜索截图.ef7ebd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/1搜索截图.jpg
// module id = 5Rd/
// module chunks = 33